//React
import React, { useState } from 'react';

//React Redux
import { useDispatch, useSelector } from 'react-redux';

//MUI
import {
  Button, TextField
  , LinearProgress, CircularProgress, Tooltip
} from '@mui/material';
import { CloseSharp as CloseSharpIcon, Label } from '@mui/icons-material';
import { Box } from '@mui/system';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { styled } from '@mui/material/styles';
//Moments
import moment from 'moment';

//APP's
import { SUPPORT_REQUEST_SUCCESS, SUPPORT_REQUEST_FAILED } from "../../actions/types";
import theme from '../../theme';
import DataService from "../../services/data.service";
import { API_BASE_URL } from "../../app/config";

//Styles
import './style.css';
import { getFromSession, replaceMultiText } from '../../app/util';

const RequestSupport = (props) => {
  const color = theme.palette;
  const dispatch = useDispatch();
  const { auth, app } = useSelector(state => state);
  const selectedProperty = app.current_state.app_state.property_id;
  let { user: AuthUser } = auth;
  const [submitDisabled, setSubmitDisabled] = useState(1);
  const [isRequestSuccess, setIsRequestSuccess] = useState(false);
  const [requestSuccessMsg, setRequestSuccessMsg] = useState('Your request is sent successfully, Our team will get back to you soon!');
  const [isRequestError, setIsRequestError] = useState(false);
  const [resErrorMsg, setResErrorMsg] = useState('');
  const [isrequesting, setIsrequesting] = useState(false);
  const [requestData, setRequestData] = useState({
    email: AuthUser.email,
    fullname: AuthUser.fullname,
    user_id: AuthUser.user_id,
    propertyIds: selectedProperty,
    subject: "Request Support",
    message: '',
    token_string: AuthUser.token_string,
    token: AuthUser.token_string
  });

  function submitRequestTicket(payload) {
    // debugger;
    return DataService.getData({ api: 'users/send_user_feedback', request: payload })
      .then(
        (data) => {
          //Do some task here just after respons
          if (data.status === "success") {
            setIsRequestSuccess(true);
            dispatch({ type: SUPPORT_REQUEST_SUCCESS, payload: data });
            return Promise.resolve(data);
          }
          else {
            setIsRequestError(true);
            setResErrorMsg(data.message);
            dispatch({ type: SUPPORT_REQUEST_FAILED, payload: data });
            return Promise.reject(data);
          }
        }
      )
      .catch((err) => {
        setIsRequestError(true);
        setResErrorMsg(err.original.statusText || 'Something went wrong, please try again later!');
        dispatch({ type: SUPPORT_REQUEST_FAILED, payload: err });
        return Promise.reject(err);
      })
  }

  const submitFileData = async (payload) => {
    let formData = new FormData();
    let propertyIds = "[" + selectedProperty + "]";

    if (selectedImage) {
      let fNameExtension = selectedImage.name.split('.').pop();
      let newFileName = moment().format('MMM-DD_mm_ss') + "_" + propertyIds + "-Screenshot." + fNameExtension;
      formData.append('screenShot', selectedImage, newFileName);
    }
    formData.append("propertyIds", propertyIds);
    formData.append("message", payload.message);

    const token = getFromSession("token");
    let apiUrl = "users/feedback";
    let api = API_BASE_URL + "" + apiUrl;
    let res = await fetch(api, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Authorization": "Token " + token,
        // 'Content-Type': 'application/json',
      },
      redirect: "follow",
      body: formData,
    })
    const data = await res.json();
    if (data.status === "success") {
      setIsRequestSuccess(true);
      dispatch({ type: SUPPORT_REQUEST_SUCCESS, payload: data });
      return Promise.resolve(data);
    }
    else {
      setIsRequestSuccess(true);
      setRequestSuccessMsg('Something went wrong, please try again later!');
      dispatch({ type: SUPPORT_REQUEST_FAILED, payload: data });
      return Promise.reject(data);
    }
  }



  function updateRequestData(e, type) {
    if (type !== 'screenShot') {
      requestData[type] = e.target.value;
    }
    setRequestData({ ...requestData });
    if (requestData.fullname !== '' && requestData.email !== '' && requestData.message !== '') {
      setSubmitDisabled(0);
    } else {
      setSubmitDisabled(1);
    }
  }
  function handleSubmit(event) {
    event.preventDefault();
    setIsrequesting(true);
    let payload = requestData;
    // submitRequestTicket(payload)
    submitFileData(payload)
      .then((rs) => {
        setIsrequesting(false);
        setIsRequestSuccess(true);
      })
      .catch((err) => {
        setIsrequesting(false);
        setIsRequestError(true);
      })
  }
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const handleChangeImage = (e) => {
    setSelectedImage(e.target.files[0])
    updateRequestData(e.target.files[0], 'screenShot')
  }
  const handleRemoveImage = (e) => {
    setSelectedImage(null)
    delete requestData['screenShot'];
  }
  let wid = (isRequestSuccess) ? "18vw" : "38vw";
  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { lg:wid, xs: '90vw' }, height: 'auto',
      bgcolor: '#fff',
      boxShadow: 24, borderRadius: '5px'
    }}>
      <div className="pop-up-header clearfix request-popup-header">
        <Box sx={{ float: 'left' }}>
          <div className="tile-title" data-tile-icon="icon-icon-events" data-id="events">
            <span><svg className='phone-icon' width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.6354 10.1417L10.323 8.65743L10.3138 8.65321C10.1419 8.57966 9.95429 8.55015 9.76805 8.56734C9.58181 8.58452 9.40279 8.64787 9.24719 8.75165C9.22887 8.76375 9.21127 8.7769 9.19446 8.79103L7.48305 10.25C6.39883 9.72337 5.27946 8.61243 4.75282 7.54228L6.21391 5.80485C6.22798 5.78728 6.24133 5.7697 6.25399 5.75071C6.35554 5.59554 6.41716 5.41766 6.43335 5.23291C6.44954 5.04817 6.41981 4.86229 6.3468 4.69181V4.68337L4.85829 1.36532C4.76178 1.14262 4.59583 0.957099 4.38522 0.836459C4.1746 0.715819 3.93062 0.66653 3.68969 0.695948C2.73694 0.82132 1.8624 1.28922 1.22941 2.01226C0.596427 2.73531 0.248284 3.66404 0.250006 4.62501C0.250006 10.2078 4.79219 14.75 10.375 14.75C11.336 14.7517 12.2647 14.4036 12.9878 13.7706C13.7108 13.1376 14.1787 12.2631 14.3041 11.3103C14.3335 11.0695 14.2844 10.8256 14.1638 10.615C14.0433 10.4044 13.858 10.2384 13.6354 10.1417ZM10.375 13.625C7.98886 13.6224 5.70119 12.6734 4.01392 10.9861C2.32666 9.29883 1.37761 7.01116 1.37501 4.62501C1.37236 3.9384 1.61973 3.2743 2.07091 2.75674C2.5221 2.23918 3.14625 1.90354 3.8268 1.81251C3.82653 1.81532 3.82653 1.81814 3.8268 1.82095L5.30337 5.12564L3.85001 6.86517C3.83525 6.88214 3.82185 6.90024 3.80993 6.91931C3.70412 7.08167 3.64205 7.26862 3.62973 7.46202C3.61741 7.65543 3.65526 7.84874 3.73962 8.02321C4.37665 9.3261 5.68938 10.629 7.00633 11.2653C7.18209 11.3489 7.37652 11.3854 7.57062 11.3714C7.76473 11.3573 7.95187 11.2932 8.11376 11.1852C8.13181 11.173 8.14918 11.1599 8.16579 11.1458L9.87508 9.68751L13.1798 11.1676C13.1798 11.1676 13.1854 11.1676 13.1875 11.1676C13.0976 11.8491 12.7624 12.4745 12.2448 12.9268C11.7271 13.3791 11.0624 13.6273 10.375 13.625Z" fill="white" />
            </svg>
            </span>
            <span className="tile-name">REQUEST SUPPORT</span>
          </div>
        </Box>
        <Box sx={{ float: 'right' }}>
          <Button className='cross-btn' sx={{ minWidth: 'auto', width: '22px', height: '22px', p: '7px', borderRadius: '50%', backgroundColor: 'dark.darkest', color: 'white.main', fontSize: '10px' }} onClick={props.handleClose}>
            <CloseSharpIcon fontSize='small' />
          </Button>
        </Box>
      </div>
      {isRequestSuccess &&
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn="span 12" sx={{ textAlign: "center", mt: 2 }}>
            <svg width="45" height="37" viewBox="0 0 45 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.8533 34.628C16.7609 29.2687 15.6988 23.9854 14.5916 18.7093C14.4977 18.2572 14.2109 17.7679 13.8662 17.4597C9.92191 13.9229 5.94859 10.416 1.98326 6.90204C1.78213 6.72352 1.58332 6.54439 1.38281 6.36818C0.890179 5.94141 0.650346 5.42466 0.858485 4.78045C1.07828 4.10592 1.58588 3.80426 2.27361 3.74113C12.1425 2.8423 22.0102 1.93885 31.8791 1.04002C35.434 0.715479 38.9903 0.405396 42.5444 0.0687017C43.2582 0.00108241 43.8642 0.113121 44.2459 0.762468C44.633 1.42273 44.3822 2.00915 43.9793 2.5819C36.2433 13.5258 28.5107 24.4738 20.784 35.4251C20.354 36.0348 19.8538 36.4655 19.0824 36.3087C18.1518 36.1205 17.9632 35.3427 17.851 34.6286L17.8533 34.628ZM20.122 31.4043C26.8145 21.9267 33.3718 12.6362 40.0552 3.17102C28.4806 4.22773 17.1571 5.26168 5.63801 6.3134C9.07297 9.36124 12.3364 12.2671 15.6288 15.143C15.787 15.2811 16.2388 15.2417 16.4626 15.1174C18.0244 14.2564 19.5646 13.3517 21.1102 12.4579C23.144 11.2824 25.1713 10.0915 27.2134 8.92863C28.3656 8.27376 29.5495 8.84415 29.5655 10.039C29.5736 10.7612 29.104 11.1491 28.5342 11.4773C25.0275 13.4949 21.5368 15.5355 18.0199 17.5335C17.5069 17.8243 17.3635 18.1198 17.4973 18.665C17.71 19.5327 17.8713 20.4117 18.0517 21.288C18.7293 24.5827 19.4023 27.8786 20.126 31.4007L20.122 31.4043Z" fill="#37B24D" />
            </svg>
          </Box>
          <Box gridColumn="span 12" sx={{ textAlign: "center", fontSize:"14px", color:"#333", mb:1}}>
          {requestSuccessMsg}
          </Box>
         
        </Box>

      }
      {!isRequestSuccess && <Box component="form" onSubmit={handleSubmit} noValidate sx={{ p: 2, pt: 1, position: 'relative' }}>
        <TextField
          size='small'
          placeholder='Name'
          margin="normal"
          required
          fullWidth
          id="name"
          label="Name"
          name="name"
          read-only
          autoComplete=""
          value={requestData.fullname}
          onChange={(e) => { updateRequestData(e, 'fullname') }}
          className="form-input"
          sx={{ backgroundColor: 'white.main', borderRadius: 1 }}
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          size='small'
          placeholder='Email'
          margin="normal"
          required
          fullWidth
          id="email"
          name="email"
          autoComplete=""
          label="Email Address"
          value={requestData.email}
          onChange={(e) => { updateRequestData(e, 'email') }}
          sx={{ backgroundColor: 'white.main', borderRadius: 1 }}
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          id="message"
          margin="normal"
          multiline
          fullWidth
          required
          rows={2}
          defaultValue=""
          value={requestData.message}
          onChange={(e) => { updateRequestData(e, 'message') }}
          label="Enter your comments"
          className="form-textarea"
          sx={{ backgroundColor: 'white.main', borderRadius: 1 }}
        />

        <Box sx={{ textAlighn: 'center' }}>
          {
            (selectedImage && <div className='image-main-div'>
              <img src={URL.createObjectURL(selectedImage)} height={150} width={150} alt="Thumb" />
              <div className='image-cross-btn' onClick={handleRemoveImage}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.8">
                    <rect width="14" height="14" rx="7" fill="white" />
                    <path d="M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17651 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.6859 5.49207 12.0862 4.04636 11.0199 2.98009C9.95365 1.91382 8.50793 1.31409 7 1.3125ZM9.05953 8.44047C9.10018 8.48112 9.13243 8.52937 9.15442 8.58248C9.17642 8.63559 9.18775 8.69251 9.18775 8.75C9.18775 8.80749 9.17642 8.86441 9.15442 8.91752C9.13243 8.97063 9.10018 9.01888 9.05953 9.05953C9.01889 9.10018 8.97063 9.13242 8.91752 9.15442C8.86441 9.17642 8.80749 9.18774 8.75 9.18774C8.69252 9.18774 8.63559 9.17642 8.58249 9.15442C8.52938 9.13242 8.48112 9.10018 8.44047 9.05953L7 7.61852L5.55953 9.05953C5.51889 9.10018 5.47063 9.13242 5.41752 9.15442C5.36441 9.17642 5.30749 9.18774 5.25 9.18774C5.19252 9.18774 5.13559 9.17642 5.08249 9.15442C5.02938 9.13242 4.98112 9.10018 4.94047 9.05953C4.89982 9.01888 4.86758 8.97063 4.84558 8.91752C4.82358 8.86441 4.81226 8.80749 4.81226 8.75C4.81226 8.69251 4.82358 8.63559 4.84558 8.58248C4.86758 8.52937 4.89982 8.48112 4.94047 8.44047L6.38149 7L4.94047 5.55953C4.85838 5.47744 4.81226 5.3661 4.81226 5.25C4.81226 5.1339 4.85838 5.02256 4.94047 4.94047C5.02256 4.85838 5.13391 4.81226 5.25 4.81226C5.3661 4.81226 5.47744 4.85838 5.55953 4.94047L7 6.38148L8.44047 4.94047C8.48112 4.89982 8.52938 4.86758 8.58249 4.84558C8.63559 4.82358 8.69252 4.81226 8.75 4.81226C8.80749 4.81226 8.86441 4.82358 8.91752 4.84558C8.97063 4.86758 9.01889 4.89982 9.05953 4.94047C9.10018 4.98112 9.13243 5.02937 9.15442 5.08248C9.17642 5.13559 9.18775 5.19251 9.18775 5.25C9.18775 5.30749 9.17642 5.36441 9.15442 5.41752C9.13243 5.47063 9.10018 5.51888 9.05953 5.55953L7.61852 7L9.05953 8.44047Z" fill="#606060" />
                  </g>
                </svg>
              </div>
            </div>)
          }
          {(!selectedImage && <>
            <Tooltip title="Image size limit is 5MB" arrow followCursor><Button component="label" variant="outlined"
              className='upload-icon'
              sx={{ mt: 1 }}
              startIcon={<FileUploadOutlinedIcon />}>
              Upload Screenshot
              <VisuallyHiddenInput type="file" onChange={handleChangeImage} />
            </Button></Tooltip>
          </>)}

        </Box>


        <Box sx={{ textAlighn: 'center' }}>
          <Button
            type="submit"
            disabled={submitDisabled}
            className="btn-submit"
            fullWidth
            variant="contained"
            // sx={{ mt: 2, mb: 2, display: 'inherit',opacity: 0.9, fontSize: 16, '&:disabled': { backgroundColor: 'green.green', cursor: 'not-allowed' } }}
            sx={{ mt: 2, mb: 2, display: 'inherit' }}
            onClick={handleSubmit}
          >
            SUBMIT
          </Button>
        </Box>

      </Box>}
      {isrequesting && (
        <Box sx={{ textAlighn: 'center', backgroundColor: 'dark.darkest', opacity: 0.8, position: 'absolute', top: 40, left: 0, width: '100%', height: '100%' }}>
          <CircularProgress
            size={40}
            sx={{
              color: 'white',
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-20px',
              marginLeft: '-20px',
            }}
          />
        </Box>

      )}
    </Box>
  )
}
export default RequestSupport;